import { parseError } from "./parseError";

export function serializeError(error: unknown) {
  return JSON.stringify(parseError(error), null, 2);
}
